
import ProfileForm from "../components/ProfileForm" // Assure-toi que ce fichier existe
import Footer from "../components/Footer"

function Profile() {
  return (
    <>

      <ProfileForm />
      <Footer />
    </>
  )
}

export default Profile
